module.exports = __webpack_public_path__ + "static/media/asset-management.ea098054.svg";